import React, { useContext, useEffect, useState } from "react"
import {
  Chip,
  Button,
  Navbar,
  NavbarBrand,
  NavbarContent,
  DropdownItem,
  Dropdown,
  DropdownMenu,
  DropdownTrigger,
  Autocomplete,
  AutocompleteItem,
  Select,
  SelectItem,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faCircleUser } from "@fortawesome/free-solid-svg-icons"
import { useQueryClient } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"

import { LayoutContext } from "../contexts/LayoutContext.jsx"
import { setLogout } from "../state/authSlice.jsx"
import { apiRoute, linksUrl } from "../constants/enum.js"
import { resetCompCode, setYearId } from "../state/companySlice.jsx"
import { isMobile } from 'react-device-detect';
import { useFetchWithBody, usePost } from "../api/reactQueryCustomHooks.jsx"
import AcYearSelection from "./AcYearSelection.jsx"




export default function Nav() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { setShowSideNav } = useContext(LayoutContext)
  const { user } = useSelector((state) => state.auth)
  const queryClient = useQueryClient()
  const { compName } = useSelector((state) => state.company)


  const handleLogout = () => {
    dispatch(setLogout())
    dispatch(resetCompCode())
    queryClient.removeQueries()
    navigate(linksUrl.login)
  }
  const handleResetPassword = () => {
    navigate(linksUrl.resetPassword)
  }

  const funGetSubString = (str) => {
    if (str && str != "") {
      if (str.length > 19)
        return str.substring(0, 19) + ".."
      else
        return str
    }
    else
      return str
  }

  return (
    <>
      <Navbar height={"3rem"} className="  z-[99] sticky  bg-sky-900  " >
        <NavbarContent justify="start" >
          <NavbarBrand className=" flex items-center gap-0 ">

            {/* <div className="mr-4 flex items-center gap-2" > */}
            <Button
              variant="light"
              isIconOnly
              aria-label="Like"
              size="sm"
              className="text-custom-text-white"
              onPress={() => {
                setShowSideNav((prev) => !prev)
              }}
            >
              <FontAwesomeIcon icon={faBars} size="xl" />
            </Button>
            <Link to={linksUrl.dashboard.tradingDashboard}>  <p className="font-bold  text-custom-text-white">WINAPP</p></Link>
            <Chip radius="sm" variant="light" className={`text-custom-text-white ${isMobile?"text-xs":"text-sm"}  bold uppercase`} >
              <Link to={linksUrl.companies}>
                {compName && compName.length == 1 ? funGetSubString(compName[0]) :
                  compName && compName.length > 1 ? funGetSubString(compName[0]) + " & Other" :
                    user?.clientName}
              </Link>
            </Chip>
            {/* <>
                <Button
                  variant="light"
                  isIconOnly
                  aria-label="Like"
                  size="sm"
                  className="text-custom-text-white"
                  onPress={() => {
                    setShowSideNav((prev) => !prev)
                  }}
                >
                  <FontAwesomeIcon icon={faBars} size="xl" />
                </Button>
                <p className="font-bold  text-custom-text-white">WINAPP</p>
                <Chip radius="sm" variant="light" className="text-custom-text-white  bold uppercase" >{user?.clientName}</Chip>


              </>
            ) */}

          </NavbarBrand>
          {/* <NavbarBrand className="">
            {isMobile ? (

              <div className=" flex flex-wrap text-custom-text-white text-xs uppercase"
                style={{ fontSize: "0.6rem" }} >

                <div>  <Link to={linksUrl.companies}> {compName && compName.length > 0 ? funGetSubString(compName[0]) : ""}</Link></div>
                <div>  <Link to={linksUrl.companies}>{compName && compName.length > 1 ? " &Other" : ""}</Link></div>
              </div>

            ) :
              <div className=" flex text-custom-text-white uppercase"
                style={{ fontSize: "12px" }} >

                <div><Link to={linksUrl.companies}>  {compName && compName.length > 0 ? compName[0] : ""}</Link></div>
                <div><Link to={linksUrl.companies}>  {compName && compName.length > 1 ? " & Other" : ""}</Link></div>

              </div>}
          </NavbarBrand> */}
          <NavbarBrand >
            {!isMobile ?
              <AcYearSelection></AcYearSelection> : ""}

          </NavbarBrand>


        </NavbarContent>

        <NavbarContent as="div" className="items-center" justify="end">
          <Dropdown placement="bottom-end" >
            <DropdownTrigger>

              <FontAwesomeIcon icon={faCircleUser} size="xl" className="text-custom-text-white" />

            </DropdownTrigger>
            <DropdownMenu aria-label="Profile Actions" variant="flat">
              <DropdownItem key="profile" className="h-14 gap-2">
                <p >Signed in as</p>
                <p className="font-semibold">{user?.username}</p>
                <p className="font-semibold">
                  {user?.firstName} {user?.lastName}
                </p>
              </DropdownItem>
              <DropdownItem key="ResetPassword" onPress={handleResetPassword} >
                Reset Password
                {/* <div onClick={handleResetPassword} >Reset Password</div> */}
                {/* <div><Link to={linksUrl.resetPassword} >Reset re Password</Link></div> */}
              </DropdownItem>
              <DropdownItem key="logout" color="danger" className="text-custom-text-white bg-primary-text-color" onPress={handleLogout}>
                Log Out
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </NavbarContent>

      </Navbar>

      <div className=" fixed top-17 z-[39] w-full mx-auto " >
        {isMobile ?
          <div className="mx-auto bg-gradient-to-tl from-amber-300 to-amber-200  border-t-0 border-sky-800">
            <AcYearSelection></AcYearSelection></div> : ""}
      </div>
    </>
  )
}
